<template>
  <div class="!w-[200px] !h-[200px]">
    <img
      src="/landing/logo/logo.webp"
      alt="Saraf Logo"
      class="w-full h-full object-cover"
      loading="lazy"
    />
  </div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
